import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import BreadCrumb from "../Header/SecondHeader";
import trans from "../../utils";
import { popupcontext } from "../../context/Popupscontext";
import POIsHead from "./POIsParts/POIsHeader";
import POIsForm from "./POIsForm/POIsForm";
import POIstable from "./POIstable/POIstable";
import POIsMap from "./POIsMap/POIsMap";
import { useGetMapPOISQuery } from "../../Redux/service/POIS/POIs";
import { filtrationcontext } from "../../context/Filtercontext";
import usePermission from "../../hooks/usePermission";

export default function POIs() {
	const { handleShow, setEdited, deleteItem, setDeleteItem } =
		useContext(popupcontext);
	const { searchQuery } = useContext(filtrationcontext);
	const { create } = usePermission("POIS");
	const [viewType, setViewType] = useState("List");
	const [filter, setFilter] = useState({
		type: null,
		country: null,
		city: null,
		state: null,
		status: null,
	});
	const [currentPage, setCurrentPage] = useState(1);

	const [LatLng, setLatLng] = useState({ lat: null, lon: null, zoom: null });
	const [mapId, setMapId] = useState();
	const buildQueryString = (filterObj) => {
		const query = Object.entries(filterObj)
			.filter(
				([_, value]) => value !== null && value !== "" && value !== undefined
			)
			.map(([key, value]) => `${key}=${value}`)
			.join("&");

		return query ? `?${query}` : "";
	};

	const queryString = buildQueryString(filter);
	const {
		data: MapPOISdata,
		isLoading: MapLoading,
		refetch: MapRefetch,
	} = useGetMapPOISQuery({ search: searchQuery, queryString, status: "true" });

	useEffect(() => {
		if (deleteItem.condition === true && deleteItem.value === "pois") {
			MapRefetch();
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		deleteItem.condition,
		deleteItem.value,
		MapRefetch,
		setDeleteItem,
		MapPOISdata?.data,
	]);
	return (
		<>
			<Helmet>
				<title>POIs</title>
				<meta name="description" content="POIs" />
			</Helmet>
			<BreadCrumb
				title={trans("Point Of Interest")}
				add={create ? trans("Add new POI") : null}
				onClick={() => handleShow("addForm")}
			/>
			<POIsHead
				viewType={viewType}
				setViewType={setViewType}
				setFilter={setFilter}
				setLatLng={setLatLng}
				setCurrentPage={setCurrentPage}
			/>
			{viewType === "List" ? (
				<POIstable
					queryString={queryString}
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
				/>
			) : (
				<POIsMap
					POISdata={MapPOISdata}
					MapLoading={MapLoading}
					queryString={queryString}
					setMapId={setMapId}
					LatLng={LatLng}
				/>
			)}

			<POIsForm MapRefetch={MapRefetch} />
		</>
	);
}
